import { coerceStringArray } from '@angular/cdk/coercion';
import { Component, SimpleChanges, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';
import { ChangeDetectorRef } from '@angular/core';
declare var bootstrap: any;
@Component({
  selector: 'app-application-api',
  templateUrl: './application-api.component.html',
  styleUrls: ['./application-api.component.scss'],
})
export class ApplicationApiComponent extends BaseListCtl {
  //Contains application id of usecases
  public applicationId: number = 0;

  public common_message = '';

  public isProfileTabActive: boolean = false;

  /**
   * Parent usecases
   */
  public parentUsecases: { [key: string]: any } = {};
  activeTab: 'basic' | 'advance' = 'basic';

  public parentUsecaseDependency: { [key: string]: any } = {};
  timeFormat: '24' | '12' = '24';
  itimeFormat: '24' | '12' = '24';
  defaultValueError: any;
  Array: any;

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
  ) {
    super('', locator, route);
    locator.config
      .getProperty('endpoint.userstory')
      .then((property: string) => {
        this.initApiEndpoint(property);
      });
    let _self = this;

    _self.applicationId = Number(this.route.snapshot.paramMap.get('appId'));
    _self.form.data['appId'] = _self.applicationId;
    _self.form.searchParams['appId'] = _self.applicationId;
    _self.form.searchParams['orderBy'] = 'name';

    _self.getApplicationDetails(_self.applicationId);
    _self.searchArchived();
    _self.form.data['groupFilter'] = 1;

    if (_self.atribForm['data']['codeType']) {
      _self.atribForm['data']['codeType'] = 'none';
    }

    if (_self.atribForm['data']['listType']) {
      _self.atribForm['data']['listType'] = 'none';
    }

    if (_self.atribForm['data']['showVertical']) {
      _self.atribForm['data']['showVertical'] = 'horizontal';
    }
  }

  override preload(): void {}

  searchArchived(callback?: any) {
    var _self = this;

    _self.form.searchError = false;
    _self.form.searchMessage = '';

    this.locator.config
      .getProperty('endpoint.userstory')
      .then((property: string) => {
        let url = property + '/searchArchived/' + _self.form.pageNo;
        _self.form.searchParams['pageSize'] = _self.form.pageSize;

        this.locator.http.post(
          url,
          _self.form.searchParams,
          function (res: any, error: any) {
            if (error) {
              if (callback) {
                callback(error);
              }

              return;
            }

            _self.form.searchError = !res.success;
            _self.form.searchMessage = res.result['message'];

            if (res.success) {
              _self.form.archivedlist = res.result.data;
              _self.form.pageCount = res.result.pageCount;
              _self.form.pageSize = res.result.pageSize;
              _self.form.pageNos = _self.form.pageNo;
              _self.form.pageNoList = [];
              //Build page number list
              for (let i = 0; i < _self.form.pageCount; i++) {
                _self.form.pageNoList.push(i);
              }

              //Check empty list
              if (_self.form.archivedlist.length == 0) {
                _self.form.message = 'No record found';
                _self.form.error = true;
              }

              // Add data in Datatable
              //_self.initializeDataTable();

              if (callback) {
                callback();
              }
            }

            if (callback) {
              callback();
            }
          },
        );
      });
  }

  toggleTab(tab: string): void {
    this.isProfileTabActive = tab === 'profile';
  }

  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.name = data.name;
    form.title = data.title;
    form.code = data.code;
    form.description = data.description;
    form.appId = data.appId;
    form.appName = data.appName;
    form.archiveEnabled = data.archiveEnabled;
    form.attachmentEnabled = data.attachmentEnabled;
    form.changeLog = data.changeLog;
    form.commentEnabled = data.commentEnabled;
    form.emailEnabled = data.emailEnabled;
    form.exportEnabled = data.exportEnabled;
    form.versionHistory = data.versionHistory;
    form.groupFilter = data.groupFilter;
    form.userFilter = data.userFilter;
    form.excelAttributes = data.excelAttributes;
    form.dropdown = data.dropdown;
    form.dropdownList = data.dropdownList;
    form.parentUsecases = data.parentUsecases;
    this.parentUsecases = data.parentUsecases;
    form.tagenable = data.tagenable;
    form.defaultValue = data.defaultValue;
    form.parentUsecaseDependency = data.parentUsecaseDependency;
    this.parentUsecaseDependency = data.parentUsecaseDependency;
    if (data.unique) form.unique = data.unique;
  }

  override delete(id: number) {
    let _self = this;
    super.delete(id, (res: any, error: any) => {
      if (error) {
        return;
      }
      if (res.success) {
        _self.getUsecase(0);
        _self.searchArchived();
      }
    });
  }

  /**
   * Filer list by usecase name
   */
  public searchUsecaseItem: string = '';

  /**
   *
   * @returns Filter useacases
   */
  public filterUsecases(): any {
    let searchTerm = this.searchUsecaseItem.toLowerCase();
    return this.form.list.filter((e: any) =>
      (e['name'] + '').toLowerCase().includes(searchTerm),
    );
  }

  /**
   * Toggle enable attributes
   * @param val
   * @param obj
   * @param name
   */
  public async toggleVal(val: any, obj: any, name: string) {
    // store original UI click value
    const originalVal = val;

    if (name === 'required') {
      if (this.atribForm['data']['system']) {
        this.atribForm['data']['required'] = false;
        this.atribForm['data']['required'] = null;
        return;
      }
    }

    if (name === 'system') {
      if (this.atribForm['data']['required']) {
        this.atribForm['data']['system'] = false;
        this.atribForm['data']['system'] = null;
        return;
      }
    }

    if (name == 'unique') {
      if (this.atribForm['data']['disable']) {
        alert('You cannot set unique constraint when attribute is disabled');
        this.atribForm['data']['unique'] = 0;
        return;
      }
    }

    if (name == 'disable') {
      if (this.atribForm['data']['unique']) {
        alert('You cannot disable attribute when unique constraint is set');
        this.atribForm['data']['disable'] = 0;
        return;
      }
    }

    // ✅ delay final assignment so UI settles
    setTimeout(() => {
      obj[name] = originalVal ? 1 : 0;
    }, 0);
  }

  public apiId: number = 0;

  public selectedUsecaseId: number | null = null;
  public appname: any;
  public usecasename: any;

  public getUsecase(id: number) {
    this.ruleList = [];

    let _self = this;
    _self.apiId = id;
    _self.selectedUsecaseId = id;
    _self.get(id, () => {
      if (id > 0) {
        _self.getAttributeListById(id);
        _self.getRules();
        console.log('_self.form.data', _self.form.data);
        _self.appname = _self.form.data['appName'];
        _self.usecasename = _self.form.data['name'];
      } else {
        _self.form.data['appId'] = _self.applicationId;
        _self.form.data['groupFilter'] = 1;
      }
    });
    _self.parentUsecases = {};
  }

  //Usecase attributes
  public attributeList = [];

  /**
   * Get usecase attribute
   * @param usercaseId
   */
  public getAttributeListById(usercaseId: number) {
    let _self = this;
    let url =
      _self.locator.config.get('endpoint.userstory.attributes') +
      '/list/' +
      usercaseId;

    _self.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }

      let data = res.result['data'];
      data.forEach((attr: any) => {
        if (attr.type === 'idate') {
          if (attr.minDate) {
            attr.minDate = _self.convertIntoLocalDate(attr.minDate);
          }
          // convert maxDate
          if (attr.maxDate) {
            attr.maxDate = _self.convertIntoLocalDate(attr.maxDate);
          }
        }
      });
      _self.attributeList = data;
    });
  }

  /**
   * Filer attribute list by label of type
   */
  public searchAttributeItem: string = '';

  public attribFilter: string = '';

  public setAttribFilter(name: string) {
    this.attribFilter = name;
  }

  public filterAttributesByLabelType(): any {
    let _self = this;
    let searchTerm = this.searchAttributeItem.toLowerCase();
    if (_self.attribFilter.length > 0) {
      return this.attributeList
        .filter((e) => e[_self.attribFilter] == '1')
        .filter((e) => e['type'] != 'tag')
        .filter((e) =>
          (e['label'] + e['type'] + '').toLowerCase().includes(searchTerm),
        );
    } else {
      return this.attributeList
        .filter((e) => e['type'] != 'tag')
        .filter((e) =>
          (e['label'] + e['type'] + '').toLowerCase().includes(searchTerm),
        );
    }
  }

  /**
   * Filter attribute list
   *
   * @returns
   */
  public filterAttributes(): any {
    const allowedTypes = [
      'text',
      'date',
      'number',
      'object',
      'email',
      'time',
      'url',
      'map',
      'textarea',
      'decimal',
    ];

    return this.attributeList.filter((e) => allowedTypes.includes(e['type']));
  }

  public allowedTypes(): any {
  const allowedTypes = [
    'text',
    'date',
    'number',
    'object',
    'email',
    'time',
    'url',
    'map',
    'textarea',
    'decimal',
    'idate',
    'itime',
    'dateandtime',
    'combobox',
    'json',
    'location',
    'boolean',
    'list',       
    'long',       
    'phone',     
    'file',       
    'doc',       
    'expression'
     
  ];

  const selectedCodes = this.form.data['excelAttributes'] || [];

  return this.attributeList.filter(
    (e) =>
      allowedTypes.includes(e['type']) && !selectedCodes.includes(e['code']),
  );
}

  public labelListAttributes(): any {
    const allowedTypes = ['text','email'];
    // return this.attributeList.filter((e) => allowedTypes.includes(e['type']));
    const selectedCodes = this.form.data['dropdown'] || [];

    return this.attributeList.filter(
      (e) =>
        allowedTypes.includes(e['type']) && !selectedCodes.includes(e['code']),
    );
  }

  public filterAttributesByDepAttribute(): any {
    return this.attributeList.filter((item: any) => {
      const matchesDepAttribute = this.attributeList.some(
        (otherItem: any) => otherItem.depAttribute === item.code,
      );
      if (matchesDepAttribute) {
        return false;
      }
      return true;
    });
  }

  public filterAttributesComposite(): any {
    const usedInComposite: string[] = [];

    // Flatten all previously created composite keys
    if (Array.isArray(this.form.data?.['unique'])) {
      this.form.data['unique'].forEach((entry: any) => {
        if (Array.isArray(entry)) {
          usedInComposite.push(...entry);
        } else if (typeof entry === 'string') {
          usedInComposite.push(entry);
        }
      });
    }

    return this.attributeList.filter((item: any) => {
      // Exclude items with type 'doc' or 'file'
      if (item.type === 'doc' || item.type === 'file') {
        return false;
      }

      // 3. Exclude attributes already used in composite keys
      if (usedInComposite.includes(item.code)) {
        return false;
      }

      // 4. Exclude items used as depAttribute by other attributes
      const isDependedOn = this.attributeList.some(
        (otherItem: any) => otherItem.depAttribute === item.code,
      );

      return !isDependedOn;
    });
  }

  selectedParentId: any = '';
  selectedParentName: string = '';

  onSelectParent(item: any) {
    this.selectedParentId = item.id;
    this.selectedParentName = `${item.name} (${item.code})`;
  }

  /**
   * Contains attribute data
   */
  public atribForm: any = {
    error: false,
    message: null,
    preload: null,
    inputerror: {},
    data: {},
  };

  public sequence: any = {
    data: {},
    preload: null,
    error: false,
    message: null,
    inputerror: {},
  };

  /**
   * Get an attribute
   *
   * @param id
   * @returns
   */
  public getAttribute(id: number) {
    let _self = this;

    //reset form
    // when get call all message flag need to reset
    _self.atribForm['error'] = '';
    _self.atribForm['message'] = '';
    _self.atribForm['inputerror'] = {};

    if (id == 0) {
      _self.atribForm['data'] = {};
      return;
    }
    this.sequence.data.prefix = '';
    ((this.sequence.data.suffix = ''), (this.sequence.data.startIndex = 0));
    this.sequence.data.id = '';

    let url =
      _self.locator.config.get('endpoint.userstory.attributes') + '/get/' + id;

    _self.locator.http.get(url, (res: any, error: boolean) => {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.atribForm['error'] = !res.success;
      _self.atribForm['message'] = res.message;
      if (res.success) {
        _self.atribForm['data'] = res.result['data'];

        if (_self.atribForm['data']['type'] === 'idate') {
          if (_self.atribForm['data']['minDate']) {
            _self.atribForm['data']['minDate'] = _self.convertIntoLocalDate(
              _self.atribForm['data']['minDate'],
            );
          }

          if (_self.atribForm['data']['maxDate']) {
            _self.atribForm['data']['maxDate'] = _self.convertIntoLocalDate(
              _self.atribForm['data']['maxDate'],
            );
          }
        }

        // Populate parent usecase Dependency form
        if (_self.atribForm['data']['timeFormat']) {
          this.timeFormat = this.atribForm['data']['timeFormat'] || '24';
        }

        if (_self.atribForm['data']['itimeFormat']) {
          this.timeFormat = this.atribForm['data']['itimeFormat'] || '24';
        }

        if (_self.atribForm['data']['dateTimeFormat']) {
          this.dateTimeFormat =
            this.atribForm['data']['dateTimeFormat'] || this.dateTimeFormat;
        }

        if (_self.atribForm['data']['sequenceId']) {
          _self.atribForm['error'] = '';
          _self.atribForm['message'] = '';
          _self.getSequenceData(_self.atribForm['data']['sequenceId']);
        } else {
          _self.atribForm['error'] = !res.success;
          _self.atribForm['message'] = res.message;
        }
        _self.parentUsecaseDependency = {};
        if (
          _self.atribForm['data']['parentUsecaseDependency'] !== null &&
          _self.atribForm['data']['parentUsecaseDependency'] !== undefined
        ) {
          _self.populateParentUsecaseDependency(
            _self.atribForm['data']['parentUsecaseDependency'],
          );
        }
      }
    });
  }

  public getSequenceData(id: any) {
    if (id == 0 || id == null) {
      return;
    }
    let _self = this;
    let url = _self.locator.config.get('endpoint.sequence') + '/get/' + id;
    _self.locator.http.get(url, (res: any, error: boolean) => {
      if (error) {
        alert('Server Error:' + error);
        return;
      }

      if (res.success) {
        _self.sequence['data'] = res.result['data'];
        console.log(_self.sequence['data']);
        _self.atribForm['error'] = res.success;
        _self.atribForm['message'] = res.message;
      } else {
        console.log('hahahaha');
        _self.atribForm['error'] = res.success;
        _self.atribForm['message'] = res.message;
      }
    });
  }

  /**
   * Delete an attribute
   * @param id
   * @returns
   */
  public deleteAttribute(id: number) {
    let _self = this;
    if (id > 0) {
      let flag = confirm('Are you sure');
      if (flag == false) {
        _self.atribForm['message'] = 'Delete request is canceled';
        return;
      }
    }

    let url =
      _self.locator.config.get('endpoint.userstory.attributes') +
      '/delete/' +
      id;

    _self.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      if (res.success) {
        alert('Success: ' + res.message);
        _self.getAttributeListById(_self.form['data']['id']);
      } else {
        alert('Error: ' + res.message);
      }
    });
  }

  /**
   * Save an attribute
   * @param id
   * @returns
   */
  public saveAttribute() {
    let _self = this;

    _self.atribForm['error'] = false;
    _self.atribForm['message'] = '';
    this.cdRef.detectChanges();

    const attrData = _self.atribForm['data'];
    const isEdit = !!attrData['id'];

    if (isEdit) {
      const existingAttr = _self.attributeList.find(
        (item: any) => item.id === attrData['id'],
      );

      if (existingAttr) {
        const existingType = existingAttr['type'];
        const newType = attrData['type'];

      if (
          (existingType === 'time' || existingType === 'itime') &&
          newType !== existingType
      ) {
        _self.atribForm['error'] = true;
        _self.atribForm['message'] =
            `Changing the type of '${existingType}' attribute is not allowed.`;
          return;
        }

        if (
          (newType === 'time' || newType === 'itime') &&
          existingType !== newType
        ) {
          _self.atribForm['error'] = true;
          _self.atribForm['message'] =
            `Changing attribute type to '${newType}' is not allowed.`;
        return;
      }
    }
    }

    if (this.atribForm.data.type === 'idate') {
      const data = this.atribForm.data;

      if (data.minDate && data.minDate.toString().trim() !== '') {
        const utcIso = new Date(data.minDate).toISOString();
        data.minDate = utcIso;
      } else {
        data.minDate = null;
      }

      if (data.maxDate && data.maxDate.toString().trim() !== '') {
        const utcIso = new Date(data.maxDate).toISOString();
        data.maxDate = utcIso;
      } else {
        data.maxDate = null;
      }
    }

    const isValidDefaultValue = this.validateDefaultValue();
    if (!isValidDefaultValue) {
      console.log('Default Value is invalid. Save stopped.');
      return;
    }

    _self.atribForm['error'] = false;
    _self.atribForm['message'] = '';
    _self.atribForm['inputerror'] = {};
    _self.validateDate(_self.atribForm['data']);
    if (this.atribForm['data']['type'] === 'expression') {
      let checked = _self.validateExpression();
      if (checked === false) {
        _self.atribForm['error'] = true;
        _self.atribForm['message'] = this.validationMessage;
        this.validationMessage = '';
        return;
      }
    }

    if (this.atribForm['data']['type'] === 'combobox') {
      this.atribForm['data']['values'] = [];
    }

    if (this.atribForm['data']['type'] === 'time') {
      this.atribForm['data']['timeFormat'] = this.timeFormat;
    }
    if (this.atribForm['data']['type'] === 'itime') {
      this.atribForm['data']['itimeFormat'] = this.itimeFormat;
    }
    if (this.atribForm['data']['type'] === 'dateandtime') {
      this.atribForm['data']['dateTimeFormat'] = this.dateTimeFormat;
    }

    _self.atribForm['data']['userstoryId'] = _self.form['data']['id'];
    const formData = _self.atribForm['data'];
    const isDuplicate = _self.attributeList.some((item: any) => {
      if (!formData.code) {
        return item.label === formData.label;
      }
      return item.label === formData.label && item.code !== formData.code;
    });

    if (isDuplicate) {
      _self.atribForm['error'] = true;
      _self.atribForm['message'] = 'Duplicate label name not allowed';
      return;
    }
    let url =
      _self.locator.config.get('endpoint.userstory.attributes') + '/save';
    this.atribForm['data']['sequence'] = this.atribForm['data']['sequence']
      ? 1
      : 0;
    _self.locator.http.post(
      url,
      _self.atribForm['data'],
      (res: any, error: boolean) => {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        _self.atribForm['error'] = !res.success;
        _self.atribForm['message'] = res.message;

        if (res.success) {
          _self.atribForm['data']['id'] = res.result.data.id;
          _self.sequence['data']['id'] = res.result.data.id;
          if (_self.atribForm['data']['type'] === 'idate') {
            if (_self.atribForm['data']['minDate']) {
              _self.atribForm['data']['minDate'] = _self.convertIntoLocalDate(
                _self.atribForm['data']['minDate'],
              );
            }

            if (_self.atribForm['data']['maxDate']) {
              _self.atribForm['data']['maxDate'] = _self.convertIntoLocalDate(
                _self.atribForm['data']['maxDate'],
              );
            }
          }
          _self.getAttributeListById(_self.form['data']['id']);

          if (res.result.data['parentUsecaseDependency']) {
            _self.parentUsecaseDependency =
              res.result.data['parentUsecaseDependency'];
          }

          if (
            _self.atribForm['data']['sequence'] &&
            !_self.atribForm['data']['sequenceId']
          ) {
            _self.saveSequenceData();
          }
        } else {
          if (!res.success && res.result?.inputerror) {
            const errors = res.result.inputerror;
            let errorMessages = [];

            console.log(errors);

            for (const field in errors) {
              const error = errors[field];
              let errorMessage = '';

              if (typeof error === 'object') {
                errorMessage = `${field}: ${JSON.stringify(error)}`;
              } else {
                errorMessage = `${field}: ${error}`;
              }

              if (errorMessage.length > 18) {
                errorMessages.push(errorMessage);
              }
            }

            if (errorMessages.length > 0) {
              const firstError =
                errorMessages?.length > 1 ? errorMessages[1] : errorMessages[0];
              const messageWithoutField = firstError
                .split(':')
                .slice(1)
                .join(':')
                .trim();
              _self.atribForm['message'] = messageWithoutField;
            }

            const fullMessage = res.result?.inputerror?.uniques || '';
            const cleanedMessage = fullMessage.replace(/^\w+\s/, '');
            _self.atribForm.inputerror['label'] =
              'Attribute Name' + cleanedMessage;
          }
        }
      },
    );
  }

  public convertIntoLocalDate(utc: any) {
    const d = new Date(utc);
    const year = d.getFullYear();
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const day = d.getDate().toString().padStart(2, '0');
    const date = `${year}-${month}-${day}`;
    return date;
  }

  public saveSequenceData() {
    let _self = this;
    _self.atribForm['error'] = false;
    _self.atribForm['message'] = '';

    let url =
      _self.locator.config.get('endpoint.userstory.attributes') +
      '/createsequence';

    _self.locator.http.post(
      url,
      _self.sequence['data'],
      (res: any, error: boolean) => {
        if (error) {
          alert('Server Error:' + error);
          return;
        }

        _self.atribForm['error'] = !res.success;
        _self.atribForm['message'] = res.message;

        if (!res.success) {
          const sequenceMsg =
            'The sequence is already present. Only one sequence can be created per use case.';
          _self.atribForm['message'] =
            'Attribute saved' + '\nNote: ' + sequenceMsg;
          console.log(_self.atribForm['message']);
        } else {
          const sequenceMsg = 'Attribute and sequence saved successfully.';
          _self.atribForm['message'] = sequenceMsg;
        }
      },
    );
  }

  //Value of an attribute
  public tempAttributeValue = '';

  //Add new value to an attribute
  public addAttributeValue() {
    let val = this.tempAttributeValue.trim();
    if (val.length == 0) {
      alert('Enter a value');
      return;
    }
    let values = this.atribForm['data']['values'];
    if (!this.atribForm['data']['values']) {
      this.atribForm['data']['values'] = [];
    }
    const index = this.atribForm['data']['values'].indexOf(val);
    if (index == -1) {
      this.atribForm['data']['values'].push(val);
    }
    this.tempAttributeValue = '';
    //alert(this.atribForm['data']['values']);
  }

  //Delete new value to an attribute
  public removeAttribueValue(val: string) {
    let _self = this;
    const index = _self.atribForm['data']['values'].indexOf(val);
    if (index !== -1) {
      let flag = confirm('Are you sure');
      if (flag) _self.atribForm['data']['values'].splice(index, 1);
    }
  }

  /**
   * Add or remove an element from the list
   * @param list
   * @param val
   * @param rem
   */
  public updateList(listName: string, val: string, rem: boolean) {
    let _self = this;

    if (!_self.locator.dataValidator.isNotNull(val)) {
      return;
    }
    if (!_self.form.data[listName]) {
      _self.form.data[listName] = [];
      _self.form.data[listName].push(val);
      return;
    }

    const index = _self.form.data[listName].indexOf(val);

    if (rem) {
      // If the item is found, remove it using Array.splice
      if (index !== -1) {
        let flag = confirm('Are you sure');
        if (flag) _self.form.data[listName].splice(index, 1);
      }
    } else {
      if (index == -1) {
        _self.form.data[listName].push(val);
      }
    }
    this.selectedListLabel = '';
    this.selectedListLabelCode = '';
    this.selectedExcelAttrCode = '';
    this.selectedExcelAttrLabel = '';
  }

  //Export columns
  selectedExcelAttrCode: string = '';
  selectedExcelAttrLabel: string = '';

  selectExcelAttr(item: any) {
    this.selectedExcelAttrCode = item['code'];
    this.selectedExcelAttrLabel = item['label'];
  }

  //List Label
  selectedListLabel: string = '';
  selectedListLabelCode: string = '';

  selectListLabel(e: any) {
    this.selectedListLabel = e['label'];
    this.selectedListLabelCode = e['code'];
  }

  /**
   * Add Parent usecase
   *
   * @param id
   */
  public addParentUscase(id: any) {
    let _self = this;

    if (!(_self.form.data['id'] > 0)) {
      alert('Error: Select a usecase');
      return;
    }

    if (_self.form.data['id'] === id) {
      alert('Error: The parent use case and the source use case are the same.');
      return;
    }

    let url =
      _self.locator.config.get('endpoint.userstory') +
      '/addparent/' +
      _self.form.data['id'] +
      '/' +
      id;

    _self.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      if (res.success) {
        alert('Success: ' + res.message);
        _self.parentUsecases = res.result['data']['parentUsecases'];
        _self.form.parentUsecases = res.result['data']['parentUsecases'];
        _self.get(_self.form.data['id']);
        _self.search();
        _self.getAttributeListById(_self.apiId);
      } else {
        alert('Error: ' + res.message);
      }
    });
    this.selectedParentId = '';
    this.selectedParentName = '';
  }

  /**
   * remove parent usecase
   * @param id
   * @returns
   */
  public removeParentUscase(id: string) {
    let _self = this;

    if (!(_self.form.data['id'] > 0)) {
      alert('Error: Select a usecase');
      return;
    }

    let url =
      _self.locator.config.get('endpoint.userstory') +
      '/removeparent/' +
      _self.form.data['id'] +
      '/' +
      id;

    _self.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      if (res.success) {
        alert('Success: ' + res.message);
        _self.parentUsecases = res.result['data']['parentUsecases'];
        _self.form.parentUsecases = res.result['data']['parentUsecases'];
        _self.get(_self.form.data['id']);
        _self.search();
        _self.getAttributeListById(_self.apiId);
      } else {
        alert('Error: ' + res.message);
      }
    });
  }

  //------------Type Map------------
  public tempMapValue = '';
  public tempKey = '';

  /**
   * Add new key-value pair to the Map
   * @returns
   */
  public addAttributeMapValue(): void {
    const key = this.tempKey.trim();
    const value = this.tempMapValue.trim();

    if (key.length === 0 || value.length === 0) {
      alert('Enter both key and value');
      return;
    }

    // Ensure map array is initialized
    if (!Array.isArray(this.atribForm.data.values)) {
      this.atribForm.data.values = [];
    }

    // Check if key already exists
    const index = this.atribForm.data.values.findIndex(
      (item: { key: string; value: string }) => item.key === key,
    );
    if (index === -1) {
      this.atribForm.data.values.push({ key, value });
    } else {
      alert('Key already exists');
    }
    // Clear the input fields
    this.tempKey = '';
    this.tempMapValue = '';
  }

  validateExpressions(expression: null) {
    let _self = this;
    const errors: any = [];
    const validCodes = new Set(
      _self.attributeList.map((attr: any) => attr.code),
    );

    const extractCodesFromExpression = (expression: string) => {
      const matches = expression.match(/:([a-zA-Z0-9_]+)/g); // Match ":code"
      return matches ? matches.map((match) => match.slice(1)) : [];
    };

    if (expression) {
      const codesInExpression = extractCodesFromExpression(expression);

      const invalidCodes = codesInExpression.filter(
        (code) => !validCodes.has(code),
      );
      if (invalidCodes.length > 0) {
        errors.push(expression + ' expression is not valid');
      }
    } else {
      _self.attributeList.forEach((attr: any) => {
        if (attr.expression) {
          const codesInExpression = extractCodesFromExpression(attr.expression);

          const invalidCodes = codesInExpression.filter(
            (code) => !validCodes.has(code),
          );
          if (invalidCodes.length > 0) {
            errors.push(attr.label + ' is not valid');
          }
        }
      });
    }

    return errors.length > 0
      ? { valid: false, message: errors.join(',') }
      : { valid: true, message: 'All expressions are valid.' };
  }

  /**
   * Remove key-value pair from the Map
   * @param key
   * @returns
   */
  public removeAttribueMapValue(key: string): void {
    if (!Array.isArray(this.atribForm.data.values)) {
      return;
    }
    const index = this.atribForm.data.values.findIndex(
      (item: { key: string; value: string }) => item.key === key,
    );
    if (index !== -1) {
      const flag = confirm('Are you sure');
      if (flag) {
        this.atribForm.data.values.splice(index, 1);
      }
    }
  }

  /**
   * Move attribute index
   */
  moveIndex(id: number, position: number) {
    let _self = this;

    let url =
      _self.locator.config.get('endpoint.userstory.attributes') +
      '/move/' +
      id +
      '/' +
      position;

    _self.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      if (res.success) {
        //alert("Success: " + res.message);
        _self.attributeList = res.result.data;
      }
    });
  }

  changeOrder(id: number, position: number) {
    let _self = this;

    let url =
      _self.locator.config.get('endpoint.userstory.attributes') +
      '/changeOrder/' +
      id +
      '/' +
      position;

    _self.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      if (res.success) {
        //alert("Success: " + res.message);
        _self.attributeList = res.result.data;
      }
    });
  }

  /**
   *
   * @param event
   * @param usecaseId
   */
  public onFileChanged(event: any, usecaseId: any) {
    const fileObj = event.target.files[0];
    var _self = this;
    let url =
      _self.locator.config.get('endpoint.userstory') +
      '/importCSV/' +
      usecaseId;
    var param = {
      id: this.form.data.id,
    };
    this.locator.http.postMutipart(
      url,
      param,
      fileObj,
      function (res: any, error: any) {
        if (error) {
          alert(error);
          return;
        }
        _self.atribForm['error'] = !res.success;
        _self.atribForm['message'] = res.message;
        _self.atribForm['inputerror'] = res.result['inputerror'];
        _self.atribForm['inputerror'] = Object.values(
          res.result['inputerror'],
        ).join(', ');
        if (res.success) {
          alert(
            res.message +
              '  Upload ' +
              res.result.successfulUploads +
              ' totalRows ' +
              res.result.totalRows +
              res.result.inputerror,
          );
        }
      },
    );
  }

  //local paging api list
  currentPage = 1;
  itemsPerPage = 5;

  get paginatedUsecases() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return this.filterUsecases().slice(
      startIndex,
      startIndex + this.itemsPerPage,
    );
  }

  // Total number of pages
  get totalPages() {
    return Math.ceil(this.filterUsecases().length / this.itemsPerPage);
  }

  // Change page
  changePage(page: number) {
    if (page > 0 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }

  /**
   * Add or remove an element from the list
   * @param list
   * @param val
   * @param rem
   */
  public deleteComposeList(listName: string, element: any, rem: boolean) {
    let _self = this;
    let flag = confirm('Are you sure');
    if (!flag) return;
    _self.form.data['unique'].pop(element);

    _self.form.data[listName] = element;
    // send data to  compose key end point
    let url =
      _self.locator.config.get('endpoint.userstory') + '/compkey/delete';
    _self.locator.http.post(
      url,
      _self.form.data,
      function (res: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        if (res.success) {
          _self.common_message = res.message;
          _self.getUsecase(_self.apiId);
        } else {
          alert('Error: ' + res.message);
        }
      },
    );
  }

  selectedItems: string[] = [];

  onCheckboxChange(event: any) {
    const value = event.target.value;
    if (event.target.checked) {
      this.selectedItems.push(value);
    } else {
      this.selectedItems = this.selectedItems.filter((item) => item !== value);
    }
  }

  addSelectedItems() {
    let _self = this;
    // Reset after adding
    _self.form.data['compKey'] = _self.selectedItems;

    let url = _self.locator.config.get('endpoint.userstory') + '/compkey';
    _self.locator.http.post(
      url,
      _self.form.data,
      function (res: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        if (res.success) {
          _self.selectedItems = [];
          _self.common_message = res.message;
          _self.getUsecase(_self.apiId);
        } else {
          alert('Error: ' + res.message);
        }
      },
    );
  }

  // Add selected items to form data
  addSelectedItems1() {
    let _self = this;
    if (_self.form.data['unique'])
      _self.form.data['unique'] = [
        ...new Set([..._self.form.data['unique'], ..._self.selectedItems]),
      ];
    else _self.form.data['unique'] = _self.selectedItems;

    _self.selectedItems = []; // Reset after adding
    _self.form.data['compKey'] = _self.form.data['unique'];

    let url = _self.locator.config.get('endpoint.userstory') + '/compkey';
    _self.locator.http.post(
      url,
      _self.form.data,
      function (res: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        if (res.success) {
          alert('Success: ' + res.message);
        } else {
          alert('Error: ' + res.message);
        }
      },
    );
  }

  // Check if the item is selected
  isSelected(value: string) {
    return this.form?.data['compKey']?.includes(value);
  }

  // Remove an item from the selected list
  removeItem(item: string) {
    this.form.data['compKey'] = this.form.data['compKey'].filter(
      (i: any) => i !== item,
    );
  }

  ngOnChanges(changes: SimpleChanges) {}

  getDescription(field: any) {
    if (field['description']) {
      return field['description'];
    }
    return field['label'];
  }

  closeAlert(i: number) {
    const inputErrors = this.atribForm['inputerror'];
    if (inputErrors && typeof inputErrors === 'object') {
      const keys = Object.keys(inputErrors);
      const keyToDelete = keys[i];
      if (keyToDelete !== undefined) {
        delete inputErrors[keyToDelete];
      } else {
        console.error('Invalid index:', i);
      }
    } else {
      console.error('atribForm.inputerror is not an object or is undefined');
    }
  }

  /**
   * Contains attribute data
   */
  public applicationForm: any = {
    error: false, //error
    message: null, //error or success message
    preload: null, // preload data
    inputerror: {}, // form input error messages
    data: {},
  };

  /**
   * Get Application details
   */
  getApplicationDetails(id: any) {
    let _self = this;
    //localhost:8085/ctl/application/get/10087390
    let url = _self.locator.config.get('endpoint.application') + '/get/' + id;

    _self.locator.http.get(url, (res: any, error: boolean) => {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.applicationForm['error'] = !res.success;
      _self.applicationForm['message'] = res.message;
      _self.applicationForm['inputerror'] = res.result['inputerror'];
      if (res.success) {
        _self.applicationForm['data'] = res.result['data'];
      }
    });
  }

  /**
   * populateParentUsecaseDependency
   * @param data
   */
  populateParentUsecaseDependency(data: any) {
    let _self = this;
    _self.parentUsecaseDependency = data;
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        _self.atribForm['data']['parentUseDependency'] = data[key]['parentId'];
      }
    }
  }

  /**
   * Remove Parent Usecase Dependency
   * @param id
   */
  public removeParentUscaseDependency(id: string) {
    let _self = this;

    let url =
      _self.locator.config.get('endpoint.userstory.attributes') +
      '/removeParentUsecaseDependency/' +
      _self.atribForm['data']['id'] +
      '/' +
      id;

    _self.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      if (res.success) {
        alert('Success: ' + res.message);
        _self.form.parentUsecaseDependency =
          res.result['data']['parentUsecaseDependency'];
        _self.getAttribute(_self.atribForm['data']['id']);
        _self.search();
      } else {
        alert('Error: ' + res.message);
      }
    });
  }

  /**
   * Check value of label input
   * @param event
   */
  checkValue(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.trim();
    const lowerValue = value.toLowerCase();
    if (lowerValue === 'tag') {
      this.atribForm.inputerror = this.atribForm.inputerror || {};
      this.atribForm.inputerror.label = `'${value}' is not allowed as a label name`;
      return;
    } else {
      if (this.atribForm.inputerror) {
        this.atribForm.inputerror.label = '';
      }
    }
    this.atribForm.data['label'] = this.capitalizeUsecaseWords(
      this.normalizeSpaces(value),
    );
  }

  /**
   * Normalize spaces in a string to ensure only one space between words.
   * @param str - Input string to normalize.
   * @returns Normalized string with single spaces.
   */
  normalizeSpaces(str: string): string {
    return str.replace(/\s+/g, ' '); // Replace multiple spaces with a single space
  }

  /**
   * Capitalize the first letter of each word in a string.
   * @param str - Input string to capitalize.
   * @returns String with the first letter of each word capitalized.
   */
  // capitalizeWords(str: string): string {
  //   return str
  //     .split(' ') // Split the string by spaces
  //     .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
  //     .join(' '); // Join the array back into a string with spaces
  // }

  // public filterParentList(): any {
  //   return this.form.list.filter((e: any) => e['id'] != this.form.data['id']);
  // }

  public filterParentList(): any {
    // Avoid mutating this.form.list directly here!
    const currentId = this.form.data?.['id'];
    let parentCollectionNames: any[] = [];

    if (this.parentUsecases) {
      parentCollectionNames = Object.keys(this.parentUsecases);
    }
    // Filter safely without changing the original form.list
    const filteredList = (this.form.list || []).filter(
      (item: any) =>
        item.id !== currentId &&
        !parentCollectionNames.includes(item.collectionName),
    );
    return filteredList;
  }

  /**
   * Usecase name input check and correction
   * @param event
   */
  checkUsecaseName(event: Event): void {
    const input = event.target as HTMLInputElement; // Cast event target as input element
    const regex = /^[a-zA-Z0-9]+( [a-zA-Z0-9]+)?$/;
    const value = input.value.trim(); // Get the input value and trim leading/trailing spaces
    const clearVAlue = value.replace(/[^a-zA-Z0-9 ]*/g, '');
    this.form.data['name'] = this.capitalizeUsecaseWords(
      this.normalizeSpaces(clearVAlue),
    );
    if (this.form.data['name'] === '') {
      if (this.form.inputerror && this.form.inputerror.collectionName) {
        delete this.form.inputerror.collectionName;
      }
    }
  }

  /**
   * Allow Capital the whole word
   * @param str
   * @returns
   */
  capitalizeUsecaseWords(str: string): string {
    return str
      .split(' ') // Split the string by spaces
      .map(
        (word) =>
          word === word.toUpperCase() // Check if all characters are uppercase
            ? word // Keep the word as is if all characters are uppercase
            : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(), // Otherwise, capitalize the first letter
      )
      .join(' '); // Join the array back into a string with spaces
  }

  /**
   * Conditon to show size and min max
   * @returns
   */
  isConditionMet(): boolean {
    const excludedTypes = [
      'expression',
      'list',
      'map',
      'file',
      'doc',
      'date',
      'time',
      'phone',
      'email',
      'object',
    ];
    return !excludedTypes.includes(this.atribForm['data']['type']);
  }

  /**
   * Check it is parent attribute or not
   * @param value
   * @returns
   */
  checkParent(value: any): boolean {
    // Check if value has depAttribute or primaryUsecase
    if (value['depAttribute'] || value['primaryUsecase']) {
      return false;
    }
    // Check if value.code exists in any depAttribute
    const conditionMet = this.filterAttributesByLabelType().some(
      (e: any) => e.depAttribute === value['code'],
    );
    if (conditionMet) {
      return false;
    }
    // If neither condition is met, return false
    return true;
  }

  editCheck(value: any): boolean {
    const conditionMet = this.filterAttributesByLabelType().some(
      (e: any) => e.depAttribute === value['code'],
    );
    if (conditionMet) {
      return false;
    }
    return true;
  }

  /**
   * Validate If Date is Empty Or Clear
   * @param data
   */
  validateDate(data: any) {
    if (data['type'] === 'date') {
      if (!data['maxDate'] || data['maxDate'].trim() === '') {
        this.atribForm['data']['maxDate'] = null;
      }
      if (!data['minDate'] || data['minDate'].trim() === '') {
        this.atribForm['data']['minDate'] = null;
      }
    }
  }

  public expressionAttrList = [];

  public filteredOptions = [];

  filterOptions() {
    let _self = this;
    const input = this.atribForm['data']['expression'] || '';

    this.filteredOptions = this.attributeList.filter((item: any) =>
      ['text', 'decimal', 'number', 'long', 'list'].includes(item.type),
    );
  }

  selectOption(option: any) {
    // this.atribForm['data']['expression'] = `@${option.code}`;
    // console.log('this.atribForm.data.expression >>>>>> ', this.atribForm['data']['expression']);
    // this.filteredOptions = [];
    const input = this.atribForm['data']['expression'] || '';
    const lastAtIndex = input.lastIndexOf('@');

    // Replace the part after the last '@' with the selected option
    const updatedExpression = `${input.substring(0, lastAtIndex + 1)}${
      option.code
    }`;
    this.atribForm['data']['expression'] = updatedExpression;

    this.filteredOptions = [];
    // this.selectedOption = option;
    // this.dropdownOpen = false;
  }

  //------------------------------------------Draging--------------------------------------------------------

  attributeDragIndex: number | null = null;

  selectedDragAttri: any = null;

  onDragStart(event: DragEvent, value: any, index: number) {
    this.attributeDragIndex = index;
    this.selectedDragAttri = value;
    setTimeout(() => {
      (event.target as HTMLElement).classList.add('dragging');
    }, 0);
  }

  onDragOver(event: DragEvent, value: any, index: number) {
    event.preventDefault();
    if (this.attributeDragIndex === null || this.attributeDragIndex === index)
      return;
    const target = event.target as HTMLElement;
    const bounding = target.getBoundingClientRect();
    const offset = bounding.y + bounding.height / 2;
    const isAfter = event.clientY > offset;

    if (isAfter && index !== this.attributeDragIndex + 1) {
      const draggingItem = this.filterAttributesByLabelType().splice(
        this.attributeDragIndex,
        1,
      )[0];
      this.filterAttributesByLabelType().splice(index, 0, draggingItem);
      this.attributeDragIndex = index;
    } else if (!isAfter && index !== this.attributeDragIndex - 1) {
      const draggingItem = this.filterAttributesByLabelType().splice(
        this.attributeDragIndex,
        1,
      )[0];
      this.filterAttributesByLabelType().splice(index, 0, draggingItem);
      this.attributeDragIndex = index;
    }
  }

  onDrop(event: DragEvent, value: any, index: number) {
    event.preventDefault();
    if (this.attributeDragIndex !== null) {
      const finalIndex = index;
      this.moveleItem(this.attributeDragIndex, finalIndex);

      this.changeOrder(this.selectedDragAttri['id'], finalIndex);
    }
    this.cleanUpleDragState();
  }

  onDragEnd(event: DragEvent, item: any) {
    this.cleanUpleDragState();
  }

  private moveleItem(fromIndex: number, toIndex: number) {
    const item = this.filterAttributesByLabelType().splice(fromIndex, 1)[0];
    this.filterAttributesByLabelType().splice(toIndex, 0, item);
  }

  private cleanUpleDragState() {
    const draggingEl = document.querySelector('.dragging');
    if (draggingEl) draggingEl.classList.remove('dragging');
    this.attributeDragIndex = null;
    this.selectedDragAttri = null;
  }

  public ATTRIBUTE_TYPES: any = [
    { value: 'combobox', icon: '🔽', label: 'attributeslabel.combobox' },
    { value: 'date', icon: '📅', label: 'attributeslabel.date' },
    { value: 'idate', icon: '🕒', label: 'attributeslabel.idate' },
    { value: 'decimal', icon: '💲', label: 'attributeslabel.decimal' },
    { value: 'doc', icon: '📄', label: 'attributeslabel.doc' },
    { value: 'email', icon: '📧', label: 'attributeslabel.email' },
    { value: 'expression', icon: '🧮', label: 'attributeslabel.expression' },
    { value: 'file', icon: '🖼', label: 'attributeslabel.image' },
    { value: 'list', icon: '📜', label: 'attributeslabel.list' },
    { value: 'long', icon: '🔢', label: 'attributeslabel.long' },
    { value: 'map', icon: '🗺️', label: 'attributeslabel.map' },
    { value: 'number', icon: '𝟙𝟚𝟛', label: 'attributeslabel.number' },
    { value: 'object', icon: '🔲', label: 'attributeslabel.object' },
    { value: 'password', icon: '🔑', label: 'attributeslabel.password' },
    { value: 'phone', icon: '📞', label: 'attributeslabel.phone' },
    { value: 'text', icon: '✏️', label: 'attributeslabel.text' },
    { value: 'textarea', icon: '📝', label: 'attributeslabel.textarea' },
    { value: 'time', icon: '⏰', label: 'attributeslabel.time' },
    { value: 'itime', icon: '🕒', label: 'attributeslabel.itime' },
    { value: 'url', icon: '🔗', label: 'attributeslabel.url' },
    { value: 'location', icon: '🌍', label: 'attributeslabel.location' },
    { value: 'dateandtime', icon: '🕒', label: 'attributeslabel.dateandtime' },
    { value: 'boolean', icon: '✅', label: 'attributeslabel.boolean' },
    { value: 'json', icon: '🧩', label: 'attributeslabel.json' },
  ];

  // ,

  // Define date time formats array
  dateTimeFormats = [
    { value: 'yyyy-MM-dd HH:mm:ss', label: 'yyyy-MM-dd HH:mm:ss' },
    { value: 'yyyy-MM-dd HH:mm', label: 'yyyy-MM-dd HH:mm' },
    { value: 'dd/MM/yyyy HH:mm:ss', label: 'dd/MM/yyyy HH:mm:ss' },
    { value: 'MM/dd/yyyy HH:mm:ss', label: 'MM/dd/yyyy HH:mm:ss' },
    { value: "yyyy-MM-dd'T'HH:mm:ss", label: "yyyy-MM-dd'T'HH:mm:ss" },
    { value: "yyyy-MM-dd'T'HH:mm", label: "yyyy-MM-dd'T'HH:mm" },
    { value: 'dd-MM-yyyy HH:mm:ss', label: 'dd-MM-yyyy HH:mm:ss' },
    { value: 'MM-dd-yyyy HH:mm:ss', label: 'MM-dd-yyyy HH:mm:ss' },
  ];

  // Default format
  dateTimeFormat: string = 'yyyy-MM-dd HH:mm:ss';

  public attributeTypes = this.ATTRIBUTE_TYPES;

  showPopup1 = false;
  canType = true;
  isSelectingOption = false;

  onInputChange1() {
    const inputValue = this.atribForm['data']['expression'];
    // Show popup when `@` is typed and no option is selected
    if (inputValue[inputValue.length - 1] === '@' && !this.isSelectingOption) {
      this.showPopup1 = true;
      this.canType = false;
    } else {
      this.showPopup1 = false;
      this.canType = true;
    }
  }

  // Close popup when input loses focus
  onBlur1() {
    setTimeout(() => {
      this.showPopup1 = false;
    }, 200);
  }

  // Handle dropdown selection
  selectOption1(option: any) {
    this.atribForm['data']['expression'] += option['label'];
    this.showPopup1 = false;
    this.isSelectingOption = false;
    this.canType = true;
  }

  // Restrict invalid characters on keypress
  onKeyPress(event: KeyboardEvent) {
    if (!this.canType && event.key !== '@') {
      event.preventDefault();
      return;
    }

    // Allow backspace, delete, and arrow keys
    if (
      ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(event.key)
    ) {
      return;
    }
    // Allowed characters
    const allowedChars = /^[0-9+\-*/%().@]+$/;

    if (!allowedChars.test(event.key)) {
      event.preventDefault();
    }
  }

  // Validation Variables
  showValidationError = false;
  validationMessage = '';

  expressionRegex =
    /^(?:\d+(\.\d+)?|@[\w]+|\((?:[^()]*|\([^()]*\))*\))(?:\s*[+\-*/%]\s*(?:\d+(\.\d+)?|@[\w]+|\((?:[^()]*|\([^()]*\))*\)))*$/i;

  // Validate expression
  validateExpression() {
    let data = this.atribForm['data']['expression'];
    let text = '';
    for (let i = 0; i < data.length; i++) {
      if (data[i] !== ' ') {
        text += data[i];
      }
    }
    if (!this.expressionRegex.test(text)) {
      this.validationMessage =
        'Invalid expression. Ensure correct placement of operators, fields, and brackets.';
      return false;
    } else {
      if (this.checkValidExpression() == false) {
        return false;
      }
      this.showValidationError = false;
      this.validationMessage = 'Data is saved';
      return true;
    }
  }

  // Check valid expression
  checkValidExpression() {
    let data = this.atribForm['data']['expression'];
    const mappings = Object.fromEntries(
      this.attributeList?.map(({ label, code, type }) => [
        `@${label}`,
        { code, type },
      ]) || [],
    );
    // Replace @labels with corresponding types
    let updatedExpression = data.replace(/@[\w\s]+/g, (match: any) => {
      return mappings[match]?.type || match;
    });
    // If the expression has both "text" and any of the operators, return false
    if (this.findOperatorAroundText(updatedExpression)) {
      this.validationMessage =
        "Invalid Expression: You can't use , %, /, or - with text field.";
      return false;
    }

    // Allowed types mapping
    const allowedTypes: Record<string, any> = {
      text: 'text',
      date: new Date().toISOString().split('T')[0],
      number: 123,
      object: { key: 'value' },
      email: 'user@example.com',
      time: '14:30',
      url: 'https://example.com',
      map: { lat: 40.7128, lng: -74.006 },
      textarea: 'This is a long text input.',
      decimal: 123.45,
      // list: ['Apple', 'Banana', 'Cherry'],
      list: 44,
      long: 9223,
      phone: '+1-555-555-5555',
      file: { name: 'document.pdf', size: '2MB' },
      doc: { title: 'My Document', format: 'docx' },
      expression: '@#@#@{};a;a',
    };

    // Replace variables with allowed types
    updatedExpression = updatedExpression.replace(/\b\w+\b/g, (match: any) => {
      let value = allowedTypes[match];
      // Wrap strings in quotes
      if (match === 'text') {
        return `"${value}"`;
      }
      return value !== undefined ? value : match;
    });
    // Evaluate the final expression
    try {
      let ans = eval(updatedExpression);
      if (isNaN(ans) && typeof ans === 'number') {
        this.validationMessage =
          "Invalid Expression: With 'text' field, you can use only + operators.";
        console.error('Invalid Expression: Result is NaN');
        return false;
      }
    } catch (error) {
      this.validationMessage = 'Invalid Expression:';
      console.error('Invalid Expression:', error);
      return false;
    }
    return true;
  }

  findOperatorAroundText(expression: string) {
    const regex = /([-*/%])?\s*text\s*([-*/%])?/g;
    let matches = [...expression.matchAll(regex)];
    for (let match of matches) {
      const beforeOperator = match[1] || null;
      const afterOperator = match[2] || null;
      if (beforeOperator || afterOperator) {
        return true;
      }
    }
    return false;
  }

  showDefaultValueField(): boolean {
    const visibleTypes = [
      'decimal',
      'long',
      'number',
      'url',
      'textarea',
      'text',
      'email',
    ];
    return visibleTypes.includes(this.atribForm['data']['type']);
  }

  validateDefaultValue(): boolean {
    const value = this.atribForm['data']['defaultValue']?.trim();
    const type = this.atribForm['data']['type'];

    // Only validate if defaultValue is not empty
    if (!value) {
      return true;
    }

    let isValid = true;
    let errorMsg = '';

    switch (type) {
      case 'number':
      case 'long':
        isValid = /^-?\d+$/.test(value);
        errorMsg = 'Please enter a valid integer value.';
        break;
      case 'decimal':
        isValid = /^-?\d+(\.\d+)?$/.test(value);
        errorMsg = 'Please enter a valid decimal number.';
        break;
      case 'email':
        isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
        errorMsg = 'Please enter a valid email address.';
        break;
      case 'url':
        isValid =
          /^(https?:\/\/)?([\w\d\-]+\.){1,}[\w]{2,}(\/[\w\d\-._~:/?#[\]@!$&'()*+,;=.]+)?$/.test(
            value,
          );
        errorMsg = 'Please enter a valid URL.';
        break;
      case 'textarea':
        isValid = value.length > 0;
        errorMsg = 'Text cannot be empty.';
        break;
    }

    if (!isValid) {
      this.defaultValueError = errorMsg;

      // Hide message after 3 seconds
      setTimeout(() => {
        this.defaultValueError = '';
      }, 3000);

      return false; // Invalid
    } else {
      this.defaultValueError = '';
      return true; // Valid
    }
  }

  preventNegative(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (+input.value < 0) {
      input.value = '0';
      this.atribForm['data']['startIndex'] = 0;
    }
  }

  clear() {
    this.sequence.data = {};
    this.sequence.data.prefix = '';
    ((this.sequence.data.suffix = ''), (this.sequence.data.startIndex = 0));
    this.sequence.data.id = '';
  }

  showSizeINMBField(): boolean {
    const allowedTypes = ['doc', 'file'];
    return allowedTypes.includes(this.atribForm['data']['type']?.toLowerCase());
  }

  showSizeField(): boolean {
    const allowedTypes = ['phone'];
    return allowedTypes.includes(this.atribForm['data']['type']?.toLowerCase());
  }

  ruleData: any = {
    data: {},
    error: false,
    message: '',
    success: false,
  };

  ruleList: any;

  getRules(): void {
    let _self = this;
    let searchData = {
      apiId: _self.selectedUsecaseId,
    };

    _self.locator.config
      .getProperty('endpoint.application.rules')
      .then((property: string) => {
        let url = property + '/search/0';
        _self.locator.http.post(
          url,
          searchData,
          function (res: any, error: boolean) {
            if (error) {
              alert('Server Error:' + error);
              return;
            }
            _self.ruleList = res.result['data'];
          },
        );
      });
  }

  resetRuleDataForm() {
    this.ruleData = {
      data: {},
      error: false,
      message: '',
      success: false,
    };
  }

  getFormId(e: any) {
    // this.formId = e.id;
    this.getRules();
    console.log(e);
  }

  addRuleWithText() {
    let _self = this;

    _self.ruleData.data['apiId'] = _self.selectedUsecaseId;

    let name =
      _self.appname +
      ' ' +
      _self.usecasename +
      ' ' +
      _self.ruleData.data['event'];
    if (name.length > 50) {
      name = name.substring(0, 50);
    }
    _self.ruleData.data['name'] = name;
    // Get current rule id if editing (could be undefined/null if adding new)
    let currentRuleId = _self.ruleData.data['id'] || null;
    // Check duplicate ignoring current rule id
    let isDuplicate = _self.ruleList?.some(
      (item: any) =>
        item.name === _self.ruleData.data['name'] && item.id !== currentRuleId,
    );

    if (isDuplicate) {
      _self.ruleData.error = true;
      _self.ruleData.message = 'Duplicate event not allowed';
      return;
    }

    _self.locator.config
      .getProperty('endpoint.application.rules')
      .then((property: string) => {
        let url = property + '/save';

        _self.locator.http.post(
          url,
          _self.ruleData.data,
          function (res: any, error: any) {
            if (error) return;
            _self.ruleData.error = !res.success;

            if (res.success) {
              _self.ruleData.message = true;
              _self.ruleData.message = 'Rule saved successfully';
              _self.getRules();
              // (_self as any).resetRuleDataForm();
            } else {
              _self.ruleData.message = false;
              _self.ruleData.message = res.message || 'Error while saving rule';
            }
          },
        );
      });
  }

  getRule(id: any, callback?: () => void) {
    let _self = this;

    _self.locator.config
      .getProperty('endpoint.application.rules')
      .then((property: string) => {
        let url = property + '/get/' + id;

        _self.locator.http.get(url, function (res: any, error: boolean) {
          if (error) {
            alert('Server Error:' + error);
            return;
          }

          const result = res.result?.data;
          if (!result) {
            console.error('No data returned for rule');
            return;
          }

          _self.ruleData = { data: result };
          console.log(_self.ruleData);

          if (callback) callback();
        });
      });
  }

  openRuleEditModal(id: any) {
    this.getRule(id, () => {
      const modal = new bootstrap.Modal(document.getElementById('addRule')!);
      modal.show();
    });
  }

  deleteRule(id: any) {
    let _self = this;
    if (!confirm('Are you sure you want to delete this rule?')) return;

    _self.locator.config
      .getProperty('endpoint.application.rules')
      .then((property: string) => {
        let url = property + `/delete/${id}`;

        _self.locator.http.get(url, function (res: any, error: any) {
          if (error) {
            alert('Delete failed: ' + error);
            return;
          }
          _self.ruleData.message = 'Rule deleted successfully';
          _self.ruleData.success = true;
          _self.getRules();
        });
      });
  }

  setTab(tab: 'basic' | 'advance') {
    this.activeTab = tab;
  }

  openAttributeModal() {
    this.activeTab = 'basic'; // Always reset to basic tab
    this.getAttribute(0);
    this.clear();
    this.atribForm['data']['codeType'] =
      this.atribForm['data']['codeType'] || 'none';

    this.atribForm['data']['listType'] =
      this.atribForm['data']['listType'] || 'none';

    this.atribForm['data']['showVertical'] =
      this.atribForm['data']['showVertical'] || 'horizontal';
  }

  public downloadSampleCsv(): void {
    const keySuffix = this.locator.config.get('CONTEXT_PATH') + '-';
    const sid = localStorage.getItem(keySuffix + 'sessionId') || '0';

    let url =
      this.locator.config.get('endpoint.userstory.attributes') + '/sampleCsv';
    if (url) {
      url += ';jsessionid=' + sid;
    }

    this.locator.http
      .getClient()
      .get(url, { responseType: 'blob' })
      .subscribe({
        next: (data: Blob) => {
          this.downloadDataAsFile(data, 'SampleCsv.csv');
        },
        error: (err: any) => {
          console.error('CSV Download Failed:', err);
        },
      });
  }

  public downloadUserAttribute(): void {
    const keySuffix = this.locator.config.get('CONTEXT_PATH') + '-';
    const sid = localStorage.getItem(keySuffix + 'sessionId') || '0';

    let url =
      this.locator.config.get('endpoint.userstory.attributes') +
      '/export/' +
      this.apiId;
    if (url) {
      url += ';jsessionid=' + sid;
    }

    this.locator.http
      .getClient()
      .post(url, {}, { responseType: 'blob' })
      .subscribe({
        next: (data: Blob) => {
          this.downloadDataAsFile(data, 'attributeList.csv');
        },
        error: (err: any) => {
          console.error('CSV Download Failed:', err);
        },
      });
  }
  /**
   * Downalod data as file
   * @param data
   * @param fileName
   */
  public downloadDataAsFile(data: any, fileName: string) {
    //Create a dynamic link and download file
    let file = new window.Blob([data], { type: data.type });
    const downloadAncher = document.createElement('a');
    downloadAncher.style.display = 'none';
    const fileURL = URL.createObjectURL(file);
    downloadAncher.href = fileURL;
    downloadAncher.download = fileName;
    downloadAncher.click();
  }

  public errorList: { rowNumber: number; message: string }[] = [];
  public showErrorModal: boolean = false;

  public onCsvFileUpload(event: any) {
    const fileObj = event.target.files[0];
    const _self = this;
    _self.form.error = false;
    _self.form.message = '';

    const data = { usecaseId: this.selectedUsecaseId };
    const keySuffix = this.locator.config.get('CONTEXT_PATH') + '-';
    const sid = localStorage.getItem(keySuffix + 'sessionId') || '0';

    let url =
      this.locator.config.get('endpoint.userstory.attributes') +
      '/addBulkAttribute';
    if (url) {
      url += ';jsessionid=' + sid;
    }

    this.locator.http.postMutipart(
      url,
      data,
      fileObj,
      (res: any, error: any) => {
        if (error) {
          alert('Upload failed: ' + error);
          return;
        }

        _self.form.error = !res.success;

        if (res.success) {
          _self.form.message = 'File uploaded successfully';
          _self.search();

          const errorSummary = res.result.errorSummary || [];

          _self.errorList = []; // Reset error list

          for (const rowNumber in errorSummary) {
            if (errorSummary.hasOwnProperty(rowNumber)) {
              const originalMessage = errorSummary[rowNumber];

              // Remove any "Row X:" prefix from the backend message
              const cleanedMessage = originalMessage
                .replace(/^Row\s*\d+\s*:\s*/i, '')
                .trim();

              _self.errorList.push({
                // Adjust row number to actual CSV line number (header is row 1)
                rowNumber: +rowNumber + 2, // +1 if backend starts from 1, +2 if it starts from 0
                message: cleanedMessage,
              });
            }
          }

          if (_self.errorList.length > 0) {
            const modal: any = new (window as any).bootstrap.Modal(
              document.getElementById('errorModal'),
            );
            modal.show();
          } else {
            alert('No Errors. All Attribute uploaded successfully.');
          }
        } else {
          alert(res.message);
        }
      },
    );

    fileObj.value = '';
  }

  isArray(val: any): boolean {
    return Array.isArray(val);
  }
}
